export default __webpack_public_path__ + "static/media/03_postrik-sazenic.4acf049a.jpg";